import React from 'react'
import { useAuthContext } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';
// import StudentPortal from './dashboard/studentPortal';
// import StudentPortal from '../pages/dashboard/studentPortal';
import AdminPannel from '../pages/dashboard/adminPannel';
export default function PrivateRoutes({ Component }) {
    const { isAuth, user } = useAuthContext()

    if (!isAuth)
        return <Navigate to="/auth/login" />

    // if (isAuth && user.role !== "superAdmin")  // Corrected condition
    //     return <Navigate to="/dashboard" />
    if (isAuth && user.role === 'superAdmin') return <AdminPannel />
    // if (isAuth && user.role === 'student') return <StudentPortal />




    return <Component />;
};
